import {Component, Input, OnInit} from '@angular/core';
import {Langdict} from '../datamodel/langdict';

@Component({
  selector: 'app-info-box',
  templateUrl: './info-box.component.html',
  styleUrls: ['./info-box.component.css']
})
export class InfoBoxComponent implements OnInit {


  @Input()
  message: Langdict|string;

  constructor() {
  }

  ngOnInit() {
  }

}
